import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.function.bind";

var _this = this;

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

var _isTargetInsideContainer = function isTargetInsideContainer(target, container) {
  _newArrowCheck(this, _this);

  return target && (target.parentElement === container || _isTargetInsideContainer(target.parentElement, container));
}.bind(this);
/** @deprecated use element.closest() instead */


export { _isTargetInsideContainer as isTargetInsideContainer };

var _findParentWithTagName = function findParentWithTagName(child, tagName) {
  _newArrowCheck(this, _this);

  if (!child.parentElement) {
    return false;
  }

  return child.parentElement.tagName === tagName.toUpperCase() ? child.parentElement : _findParentWithTagName(child.parentElement, tagName);
}.bind(this);

export { _findParentWithTagName as findParentWithTagName };
export var overrideFocusTarget = function overrideFocusTarget(calledOnElm, focusTarget) {
  var _this2 = this;

  _newArrowCheck(this, _this);

  return calledOnElm.focus = function () {
    _newArrowCheck(this, _this2);

    return focusTarget.focus();
  }.bind(this);
}.bind(this);
export function cleanupClassNames(classNames) {
  var _this3 = this;

  var result = classNames.filter(function (elm) {
    _newArrowCheck(this, _this3);

    return !!elm;
  }.bind(this)).join(" ");
  return result ? result : undefined;
}